import { useRef, useState } from 'react'
import type { DragEvent } from 'react'

export const ACCEPT = 'image/jpeg,image/png,image/webp'
const TYPES = new Set(ACCEPT.split(','))
const MAX_BYTES = 8 * 1024 * 1024

export function fileProblem(file: File): string | null {
  if (!TYPES.has(file.type)) return `${file.name}: только JPEG, PNG или WebP`
  if (file.size > MAX_BYTES) return `${file.name}: файл больше 8 МБ`
  return null
}

const hasFiles = (e: DragEvent<HTMLElement>) => e.dataTransfer.types.includes('Files')

export function useFileDrop(onFiles: (files: File[]) => void, disabled = false) {
  const depth = useRef(0)
  const [over, setOver] = useState(false)
  const [count, setCount] = useState(0)

  const bind = {
    onDragEnter: (e: DragEvent<HTMLElement>) => {
      if (!hasFiles(e)) return
      e.preventDefault()
      e.stopPropagation()
      depth.current += 1
      setCount(e.dataTransfer.items.length)
      setOver(true)
    },
    onDragOver: (e: DragEvent<HTMLElement>) => {
      if (!hasFiles(e)) return
      e.preventDefault()
      e.stopPropagation()
      e.dataTransfer.dropEffect = disabled ? 'none' : 'copy'
    },
    onDragLeave: (e: DragEvent<HTMLElement>) => {
      if (!hasFiles(e)) return
      e.stopPropagation()
      depth.current = Math.max(0, depth.current - 1)
      if (depth.current === 0) setOver(false)
    },
    onDrop: (e: DragEvent<HTMLElement>) => {
      if (!hasFiles(e)) return
      e.preventDefault()
      e.stopPropagation()
      depth.current = 0
      setOver(false)
      const files = [...e.dataTransfer.files]
      if (!disabled && files.length > 0) onFiles(files)
    },
  }

  return { over: over && !disabled, count, bind }
}
